import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminationUpdateAction from './inseminationUpdate.action.json' with { type: 'json' }
import { inseminationObject } from '../inseminationObject'

const inseminationUpdateDefinition = defineAction({
  ...inseminationUpdateAction,

  input: inseminationObject.partial().required({ id: true }),
  output: z.object({}),
})

export default inseminationUpdateDefinition
